import { AxiosError } from "axios";

export const isProfileExpiredError = (error: unknown): boolean => {
  const axiosError = error as AxiosError<{ message?: string }>;
  return (
    axiosError?.response?.status === 403 &&
    axiosError?.response?.data?.message === "user-profile-expired"
  );
};

/** `message` is the server's diagnostic text and is never shown to an investor. */
export const getUserMessage = (error: unknown, fallback: string): string => {
  const axiosError = error as AxiosError<{ userMessage?: unknown }>;
  const userMessage = axiosError?.response?.data?.userMessage;

  return typeof userMessage === "string" && userMessage.trim()
    ? userMessage
    : fallback;
};
